define([
  'es6!lib/sumome/service/service'
], function(Service) {
  return {
    Service: Service
  };
});
